import { Fragment } from '@wordpress/element';

import { __ } from '@wordpress/i18n';

import { TabPanel, Button } from '@wordpress/components';
import { Locations } from './tabs/locations';
import { Users } from './tabs/users';
import { Devices } from './tabs/devices';
import { Dates } from './tabs/dates';

export function Tabs( props ) {
	const { addRule, rules, onSelect, activeTab } = props;

	if ( ! rules.device ) {
		rules.device = [
			{
				device: 'desktop',
				visibility: false,
			},
			{
				device: 'tablet',
				visibility: false,
			},
			{
				device: 'mobile',
				visibility: false,
			},
		];
	}

	if ( ! rules.date ) {
		rules.date = [
			{
				date: 'evergreen',
				startDate: false,
				endDate: false,
			},
		];
	}

	return (
		<TabPanel
			onSelect={ onSelect }
			tabs={ [
				{
					name: 'location',
					component: Locations,
					title:
						__( 'Locations', 'popper' ) +
						( rules.location.length ? '' : '⚠️' ),
					description: (
						<p>
							{ __(
								'Choose where you want display this popup.',
								'popper'
							) }
						</p>
					),
				},
				{
					name: 'exclude',
					component: Locations,
					title: __( 'Exclude', 'popper' ),
					description: (
						<p>
							{ __(
								"Choose where you don't want display this popup.",
								'popper'
							) }
						</p>
					),
				},
				{
					name: 'user',
					component: Users,
					title: __( 'Users', 'popper' ),
					description: (
						<p>
							{ __(
								'Choose which user will see this popup. If empty it will be shown to everybody.',
								'popper'
							) }
						</p>
					),
				},
				{
					name: 'device',
					component: Devices,
					title:
						__( 'Devices', 'popper' ) +
						( rules.device.length ? '' : '⚠️' ),
					description: (
						<p>
							{ __(
								'Choose on which device this popup will be shown. If empty it will NOT be shown.',
								'popper'
							) }
						</p>
					),
				},
				{
					name: 'date',
					component: Dates,
					title: __( 'Dates', 'popper' ),
					description: '',
				},
			] }
		>
			{ ( tabData ) => {
				const Component = tabData.component;
				return (
					<Fragment>
						<h2>{ tabData.title }</h2>
						{ tabData.description }
						<Component { ...props } />
						{ ! [ 'date', 'device' ].includes( activeTab ) && (
							<Button
								variant="primary"
								onClick={ addRule }
								size="small"
							>
								{ __( 'Add rule', 'popper' ) }
							</Button>
						) }
					</Fragment>
				);
			} }
		</TabPanel>
	);
}
